// extracted by mini-css-extract-plugin
export var externalLink = "_bv-0";
export var internalLinkLabel = "_bv-1";